// file: src/KalkulatorOstaliDohodak.js

import React, { useState, useEffect } from 'react';
import './Kalkulator.css';
import { FiFileText } from 'react-icons/fi';

function KalkulatorOstaliDohodak() {
  const [unosTip, setUnosTip] = useState('ukupan');    // 'ukupan' ili 'poslije'
  const [ukupanPrihod, setUkupanPrihod] = useState('');
  const [dohodakPoslije, setDohodakPoslije] = useState('');
  const [priznatiRashodi, setPriznatiRashodi] = useState('');
  const [errors, setErrors] = useState({
    ukupanPrihod: '',
    dohodakPoslije: '',
    priznatiRashodi: ''
  });
  const [rezultati, setRezultati] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  const validateField = (name, value) => {
    let msg = '';
    if (value.trim() === '') {
      msg = 'Ovo polje je obavezno.';
    } else if (isNaN(Number(value)) || Number(value) < 0) {
      msg = 'Unesite nenegativan broj.';
    }
    setErrors(prev => ({ ...prev, [name]: msg }));
  };

  // Kad korisnik mijenja ’ukupanPrihod’ i odabran je unosTip='ukupan'
  useEffect(() => {
    if (unosTip === 'ukupan') {
      if (
        ukupanPrihod.trim() !== '' &&
        priznatiRashodi.trim() !== '' &&
        errors.ukupanPrihod === '' &&
        errors.priznatiRashodi === ''
      ) {
        const payload = {
          ukupan_prihod: parseFloat(ukupanPrihod.replace(',', '.')),
          priznatirashodi: parseFloat(priznatiRashodi.replace(',', '.'))
        };
        fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/ostali-dohodak/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(async res => {
            if (!res.ok) {
              const err = await res.json();
              throw new Error(err.detail || 'Greška pri izračunu.');
            }
            return res.json();
          })
          .then(data => {
            setRezultati(data);
            setSubmitError(null);
          })
          .catch(err => {
            setRezultati(null);
            setSubmitError(err.message);
          });
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [ukupanPrihod, priznatiRashodi, errors.ukupanPrihod, errors.priznatiRashodi, unosTip]);

  // Kad korisnik mijenja ’dohodakPoslije’ i odabran je unosTip='poslije'
  useEffect(() => {
    if (unosTip === 'poslije') {
      if (
        dohodakPoslije.trim() !== '' &&
        priznatiRashodi.trim() !== '' &&
        errors.dohodakPoslije === '' &&
        errors.priznatiRashodi === ''
      ) {
        const payload = {
          dohodak_poslije: parseFloat(dohodakPoslije.replace(',', '.')),
          priznatirashodi: parseFloat(priznatiRashodi.replace(',', '.'))
        };
        fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/ostali-dohodak/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(async res => {
            if (!res.ok) {
              const err = await res.json();
              throw new Error(err.detail || 'Greška pri izračunu.');
            }
            return res.json();
          })
          .then(data => {
            setRezultati(data);
            setSubmitError(null);
          })
          .catch(err => {
            setRezultati(null);
            setSubmitError(err.message);
          });
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [dohodakPoslije, priznatiRashodi, errors.dohodakPoslije, errors.priznatiRashodi, unosTip]);

  const handleUkupanChange = e => {
    const v = e.target.value.replace(',', '.');
    setUkupanPrihod(v);
    validateField('ukupanPrihod', v);
  };
  const handlePoslijeChange = e => {
    const v = e.target.value.replace(',', '.');
    setDohodakPoslije(v);
    validateField('dohodakPoslije', v);
  };
  const handleRashodiChange = e => {
    const v = e.target.value.replace(',', '.');
    setPriznatiRashodi(v);
    validateField('priznatiRashodi', v);
  };
  const handleUnosTipChange = e => {
    setUnosTip(e.target.value);
    // Resetiramo sve polja i greške
    setUkupanPrihod('');
    setDohodakPoslije('');
    setPriznatiRashodi('');
    setErrors({ ukupanPrihod: '', dohodakPoslije: '', priznatiRashodi: '' });
    setRezultati(null);
    setSubmitError(null);
  };

  return (
    <div className="container">
      {/* ----- FORM CONTAINER (lijeva kartica) ----- */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Kalkulator Ostali dohodak <FiFileText />
          </h2>
        </div>

        <div className="field-group">
          <label htmlFor="unosTip" className="field-label">
            Izaberite unos<span className="required">*</span>:
          </label>
          <select
            id="unosTip"
            className="field-select"
            value={unosTip}
            onChange={handleUnosTipChange}
          >
            <option value="ukupan">Ukupan prihod</option>
            <option value="poslije">Dohodak poslije oporezivanja</option>
          </select>
        </div>

        {/* Ako je unosTip === 'ukupan', prikazujemo polje za "Ukupan prihod" */}
        {unosTip === 'ukupan' && (
          <div className="field-group">
            <label htmlFor="ukupanPrihod" className="field-label">
              Ukupan prihod<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="ukupanPrihod"
              className={`field-input ${errors.ukupanPrihod ? 'shake' : ''}`}
              placeholder="npr. 2000,00"
              value={ukupanPrihod}
              onChange={handleUkupanChange}
              onBlur={e => validateField('ukupanPrihod', e.target.value.replace(',', '.'))}
            />
            {errors.ukupanPrihod && <div className="error-text">{errors.ukupanPrihod}</div>}
          </div>
        )}

        {/* Ako je unosTip === 'poslije', prikazujemo polje za "Dohodak poslije oporezivanja" */}
        {unosTip === 'poslije' && (
          <div className="field-group">
            <label htmlFor="dohodakPoslije" className="field-label">
              Dohodak poslije oporezivanja<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="dohodakPoslije"
              className={`field-input ${errors.dohodakPoslije ? 'shake' : ''}`}
              placeholder="npr. 1479,00"
              value={dohodakPoslije}
              onChange={handlePoslijeChange}
              onBlur={e => validateField('dohodakPoslije', e.target.value.replace(',', '.'))}
            />
            {errors.dohodakPoslije && (
              <div className="error-text">{errors.dohodakPoslije}</div>
            )}
          </div>
        )}

        {/* Polje za "Priznati rashodi" */}
        <div className="field-group">
          <label htmlFor="priznatiRashodi" className="field-label">
            Priznati rashodi<span className="required">*</span>:
          </label>
          <input
            type="text"
            id="priznatiRashodi"
            className={`field-input ${errors.priznatiRashodi ? 'shake' : ''}`}
            placeholder="npr. 300,00"
            value={priznatiRashodi}
            onChange={handleRashodiChange}
            onBlur={e => validateField('priznatiRashodi', e.target.value.replace(',', '.'))}
          />
          {errors.priznatiRashodi && (
            <div className="error-text">{errors.priznatiRashodi}</div>
          )}
        </div>
      </div>

      {/* ----- RESULTS CONTAINER (desna kartica) ----- */}
      <div className="results-container card">
        {rezultati && (
          <>
            <h3 className="section-title">Rezultati</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Ukupan prihod:</span>
                <span>{rezultati.ukupan_prihod.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Dohodak poslije oporezivanja:</span>
                <span>{rezultati.dohodak_poslije.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Priznati rashodi:</span>
                <span>{rezultati.priznatirashodi.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Dohodak:</span>
                <span>{rezultati.dohodak.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Porez:</span>
                <span>{rezultati.porez.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <b><span>Ukupne obaveze:</span></b>
                <b><span>{rezultati.ukupne_obaveze.toFixed(2)}</span></b>
              </div>
            </div>
          </>
        )}
        {submitError && <div className="error-text">{submitError}</div>}
      </div>
    </div>
  );
}

export default KalkulatorOstaliDohodak;
